import { render, staticRenderFns } from "./AdminFournisseurs.vue?vue&type=template&id=51284250&"
import script from "./AdminFournisseurs.vue?vue&type=script&lang=js&"
export * from "./AdminFournisseurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports